import React from 'react';
import PropTypes from 'prop-types';

import { Button, Stack } from '@metarouter-private/mr-mui';

export default function ConfirmDeleteActions({ disabled, onConfirm, onCancel }) {
  return (
    <Stack direction="row" spacing={1}>
      <Button onClick={onCancel} color="secondary" variant="outlined">
        Cancel
      </Button>

      <Button onClick={onConfirm} disabled={disabled} color="error" data-test-id="deletePipelineButton">
        Delete Pipeline
      </Button>
    </Stack>
  );
}

ConfirmDeleteActions.propTypes = {
  disabled: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
